export default __webpack_public_path__ + "assets/webgl/fire.12686f7f.gltf";